import {
  getList,
} from "@surya-digital/leo-ts-types";
import { Answer, AnswerDTO } from "./answer";

export interface OpenEndedAnswerV1DTO {
  fieldAnswers: AnswerDTO[];
}

export class OpenEndedAnswerV1 {
  readonly isOpenEndedAnswerV1OpenEndedAnswerV1: boolean = true;

  readonly fieldAnswers: Answer[];

  static readonly constraints = {
    "fieldAnswers": {
      "minSize": 1,
    }
  }

  constructor(
  fieldAnswers: Answer[]
  ) {
    OpenEndedAnswerV1.validateFieldAnswers(fieldAnswers);
    this.fieldAnswers = fieldAnswers;
  }

  static fromDTO(dto: OpenEndedAnswerV1DTO): OpenEndedAnswerV1 {
    const fieldAnswers = getList<AnswerDTO, Answer>(
      dto,
      "fieldAnswers",
      Answer.fromDTO,
      InvalidOpenEndedAnswerV1FieldAnswersError
    );
    return new OpenEndedAnswerV1(
      fieldAnswers
    );
  }

  toDTO(): OpenEndedAnswerV1DTO {
    const dto: OpenEndedAnswerV1DTO = {
        fieldAnswers: this.fieldAnswers.map((e: Answer) => { return e.toDTO() })
    };
    return dto;
  }
  private static validateFieldAnswers = (fieldAnswers: Answer[]): void => {
    if(fieldAnswers.length < 1) {
      throw new InvalidOpenEndedAnswerV1FieldAnswersMinSizeError(
        1,
        `Attribute fieldAnswers is too short. Size is ${fieldAnswers.length}. Min size is 1.`
      );
    }
  }
  
}

OpenEndedAnswerV1.prototype.toString = function toString(): string {
  return `OpenEndedAnswerV1(fieldAnswers='${this.fieldAnswers}')`;
};

export class InvalidOpenEndedAnswerV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedAnswerV1Error";
  }
}
export class InvalidOpenEndedAnswerV1FieldAnswersError extends InvalidOpenEndedAnswerV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedAnswerV1FieldAnswersError";
  }
}

export class InvalidOpenEndedAnswerV1FieldAnswersMinSizeError extends InvalidOpenEndedAnswerV1FieldAnswersError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedAnswerV1FieldAnswersMinSizeError";
  }
}
